
import { throwError as observableThrowError, Observable, BehaviorSubject } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';


import { API } from '../../core/app-config';
import { ResponseMessage, PagerList, FPResponse,ContractType, ChecklistFileDetails, SystemSetting } from '../.././shared/shared.model';
import { SharedService } from '../../shared/shared.service';
import { Sample, Region, Technician, AdvancedSearchModel, Pagination, AdvancedSearch, JobDetailMaster, JobDetailList, SpecialService, EquipmentEntity, JobHistory, PrintcheckListModel, PrintCheckListOutput, DownloadFile, EmailJobAttachement, SendEmailJob, SystemSettings, JobPrintPre, attachmentchecklist, ChecklistAttachment, SaveDynamicChecklist, AttachmentReOrderList, WoJobStatusReasonEntity, SaveCompleteStatusReason, FileDetails, WOPunchPoints, PunchPointsList, WoPunchPointsAttachment, ScheduleToMe, AddEditWoJobEntity, userRoleDetail, AssignToTech, OTPProjectSettings, WorkDoneTimings, RefEmailPrintJobSetting } from './technician-jobs.models';
import { CustomerAndJobdetails, WorkOrderCustomerContactDetail, EditServiceContact, ManageTechnicianJobs, JobStatusReason, WoJobTaskDetails, EquipmentEntitys } from './technician-jobs.models';
import { TechnicianJobStatusUpdate, JobDetailListTab, JobEquipmentTab, AttachmentsModel, ContactType, ChecklistModel, PaymentModel, PricingModel, ConfigValue } from './technician-jobs.models';
import { PricingFormModel, SigNature, DynamicCheckList, WoAttachement, WoEquipmentEntity, UpdateSubmiteStatus, DynamicCheckListDetails, RecentOrderHistory, TechJobSubmit } from './technician-jobs.models';
import {
    SpecialServiceModel, DynamicSaveModel, DynamicModel, Titles, TechnicianDetails, JobDetailsList,
    PrintPreview, WorkRequestModel, WoJobTaskDetailsAll, CustomerTimeZone, Logo, NotesModel, WorkRequestDd,
    WorkTypeDd, WorkRequestSaveModel, ContactCFModel, EquipmentListModel, ExistingEquipmentModel, WoEquipmentCFModel, WorkRequestCFModel, EquipmentCFModel,

    BrandList, ModelList, TimezoneEntity, TaxGroup, JobSlaDetails, Company, PartPricing, jobNumber, SaveOTP, Reason, OTPDetails, Feedback, RefStatusReasonReject, AcceptReject,
    ChecklistGPSLocation
} from './technician-jobs.models';
import { CustomFieldsConfiguration } from '../../shared/custom-fields/custom-fields-models';
import { TechnicianDetail, } from '../../admin/technician/technician.models';
import { CustomerType } from 'app/layout/customer/customer.models';
import { woDetailsComponent } from 'app/layout/work-order/manage-work-order/details/wo-details.component';


@Injectable()
export class TechnicianJobService {
    constructor(private _http: Http) { }

    updateCFDF: EventEmitter<boolean> = new EventEmitter(); // Update trigger for CustomFields from Dynamic Forms
    refreshJobDuration = new EventEmitter();
    getJobDetailsList(advancedSearchModel: AdvancedSearchModel, SortBy: string, OrderBy: string, startRecord: number, EndRecord: number): Observable<JobDetailList> {
        return this._http.post(API.WORKORDER + '/WebGetTechnicianJobDetailsList/' + '?SortBy=' + SortBy + '&OrderBy=' + OrderBy + '&startRecord=' + startRecord + '&EndRecord=' + EndRecord, advancedSearchModel).pipe(
            map(this.extractData));
    }

    getAdvansedSearch(companyId: number, loginId: number): Observable<AdvancedSearch[]> {

        return this._http.get(API.COMMON + '/GetAdvansedSearch/' + companyId + "/" + loginId).pipe(
            map(res => res.json()));
    }


    getTechnicians(CompanyId: number, LogindId: number, VendorId: number, MaxRoleGroup: number): Observable<Technician[]> {
        return this._http.get(API.USER + "/GetTechAllDropDown/" + '?CompanyId=' + CompanyId +
            '&VendorId=' + VendorId +
            '&LoginId=' + LogindId +
            '&MaxRoleGroup=' + MaxRoleGroup +
            '&IsActive=' + 1).pipe(map(this.extractData));
    }

    getRegion(companyId: number, zoneId: number): Observable<Region[]> {
        return this._http.get(API.COMMON + '/GetRegion/' + companyId + "/" + zoneId).pipe(
            map(res => res.json()),
            catchError((error: any) => observableThrowError(error.json().error || 'Server error')));
    }

    getTechnician(companyId: number, vendorId: number): Observable<Technician[]> {
        return this._http.get(API.COMMON + '/GetTechnician/' + companyId + "/" + vendorId).pipe(
            map(res => res.json()),
            catchError((error: any) => observableThrowError(error.json().error || 'Server error')));
    }

    getAdvansedSearchFilter(model: Sample): Observable<JobDetailList> {
        return this._http.post(API.WORKORDER + '/GetTechnicianJobDetailsLists/' + model.SortBy + "/" + model.OrderBy + "/" + model.startRecord + "/" + model.EndRecord, model).pipe(map(this.extractData));
    }

    //Technician DetailsList Not Using
    GetCustomerAndJobDetails(CompanyId: number, JobId: number): Observable<CustomerAndJobdetails> {
        return this._http.get(API.WORKORDER + '/GetCustomerAndJobdetails/' + '/' + CompanyId + '/' + JobId).pipe(
            map(res => res.json()));
    }

    //Get Manage Technician jobs
    GetManageTechnicianJobDetails(advancedSearchModel: AdvancedSearchModel, SortBy: string, OrderBy: string, startRecord: number, EndRecord: number): Observable<ManageTechnicianJobs> {
        return this._http.post(API.WORKORDER + '/WebGetTechnicianJobAndStatusAndAppDetails/' + '?SortBy=' + SortBy + '&OrderBy=' + OrderBy + '&startRecord=' + startRecord + '&EndRecord=' + EndRecord, advancedSearchModel).pipe(
            map(this.extractData));
    }

    //WebGetInhouseJobAndStatusAndAppDetails
    GetInhouseJobAndStatusAndAppDetails(advancedSearchModel: AdvancedSearchModel, SortBy: string, OrderBy: string, startRecord: number, EndRecord: number): Observable<ManageTechnicianJobs> {
        return this._http.post(API.WORKORDER + '/WebGetInhouseJobAndStatusAndAppDetails/' + '?SortBy=' + SortBy + '&OrderBy=' + OrderBy + '&startRecord=' + startRecord + '&EndRecord=' + EndRecord, advancedSearchModel).pipe(
            map(this.extractData));
    }

    //Print preview 
    GetCustomerAndTechDetails(companyId: number, WorkorderId: number, wojobid: number, TechId: number): Observable<PrintPreview> {
        return this._http.get(API.WORKORDER + '/GetCustomerAndTechDeails/' + companyId + "/" + WorkorderId + "/" + wojobid + "/" + TechId).pipe(
            map(this.extractData));
    }

    //Edit Service Contact Get and Update
    GetCustomerEditServiceContact(CompanyId: number, JobId: number): Observable<WorkOrderCustomerContactDetail> {
        return this._http.get(API.WORKORDER + '/GetServiceContact/' + '?CompanyId=' + CompanyId + '&Wojobid=' + JobId).pipe(
            map(res => res.json()));
    }

    UpdateEditContactService(editModel: EditServiceContact): Observable<FPResponse> {
        let URL: string = API.WORKORDER + '/UpdateWorkOrderCustomerContactDetails/';
        return this._http.put(URL, editModel).pipe(map(res => res.json()));
    }

    //end

    //Get Job Complete Status
    GetCompleteAndUnresolvedReason(CompanyId: number, IsActive: number, SortBy: string, OrderBy: string, startRecord: number, EndRecord: number, WorkTypeIds: any): Observable<JobStatusReason> {
        return this._http.get(API.STATUSREASON + '/GetAll/' + '?CompanyId=' + CompanyId + '&IsActive=' + IsActive + '&SortBy=' + SortBy + '&OrderBy=' + OrderBy + '&startRecord=' + startRecord + '&EndRecord=' + EndRecord + '&WorkTypeIds=' + JSON.stringify(WorkTypeIds)).pipe(
            map(this.extractData));
    }
    getUnresolvedReason(companyId: number, id: number): Observable<JobStatusReason> {
        return this._http.get(API.STATUSREASON + '/?CompanyId=' + companyId + '&StatusReasonId=' + id).pipe(map(res => res.json()));
    }
    /**Special Instructions and Service Notes */
    //Special Instructions
    GetSpeciInstrAndServiNote(CompanyId: number, WoJobId: number, LoginId: number, TechTimeZoneId: number, CustomerId: number, woId: number): Observable<SpecialServiceModel> {
        return this._http.get(API.WORKORDER + '/GetSpecInstrServNote' + '?CompanyId=' + CompanyId + '&Wojobid=' + WoJobId + '&loginId=' + LoginId + '&TechTimeZoneId=' + TechTimeZoneId + '&CustomerId=' + CustomerId + '&woid=' + woId).pipe(
            map(this.extractData));
    }

    addSpeciInstrAndServiNote(specialService: SpecialService): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/InsertSplNotesDetails/', specialService).pipe(
            map(this.extractData));
    }

    updateSpeciInstrAndServiNote(specialService: SpecialService): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateSplNotesDetails/', specialService).pipe(
            map(this.extractData));
    }

    deleteSpeciInstrAndServiNote(companyId: number, noteId: number): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeleteSplNotes' + '?CompanyId=' + companyId + '&NotesID=' + noteId).pipe(
            map(this.extractData));
    }

    //Service Notes
    addServiceNotes(specialService: SpecialService): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/InsertWojobServiceNotes/', specialService).pipe(
            map(this.extractData));
    }

    updateServiceNotes(specialService: SpecialService): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateWojobServiceNotes/', specialService).pipe(
            map(this.extractData));
    }

    deleteServiceNotes(companyId: number, noteId: number): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeleteWojobServiceNotes' + '?CompanyId=' + companyId + '&NotesID=' + noteId).pipe(
            map(this.extractData));
    }

    /**End Special Instructions and Service Notes */

    //Technician Remarks
    addTechnicianRemarks(specialService: SpecialService): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/InsertTechRemarksNotes/', specialService).pipe(
            map(this.extractData));
    }

    updateTechnicianRemarks(specialService: SpecialService): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateTechRemarksNotes/', specialService).pipe(
            map(this.extractData));
    }

    deleteTechnicianRemarks(companyId: number, noteId: number): Observable<FPResponse> {
        ;
        return this._http.delete(API.WORKORDER + '/DeleteTechRemarksNotes' + '?CompanyId=' + companyId + '&NotesID=' + noteId).pipe(
            map(this.extractData));
    }

    //End Technician Remarks

    /**Job Details */



    getWoJobDetailsAll(companyId: number, woJobId: number, WoCategoryId: number): Observable<WoJobTaskDetailsAll> {
        return this._http.get(API.WORKORDER + '/GetJobDetailsAll' + '?CompanyId=' + companyId + '&JobId=' + woJobId + '&WoCategoryId=' + WoCategoryId).pipe(
            map(this.extractData));
    }

    /**End Job Details */

    /**Job Equipment */

    getJobEquipments(companyId: number, woJobId: number): Observable<EquipmentEntity[]> {
        return this._http.get(API.WORKORDER + '/GetEquipment' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    insertNewEquipment(equipment: EquipmentEntity[]): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/SaveEquipment/', equipment).pipe(
            map(this.extractData));
    }

    updateEquipment(equipment: EquipmentCFModel): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateEquipmentcf/', equipment).pipe(
            map(this.extractData));
    }

    deleteEquipment(companyId: number, woJobId: number, woEquipmentId): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeletWojobEquipment' + '?CompanyId=' + companyId + '&WoJobId=' + woJobId + '&WoEquipmentId=' + woEquipmentId + '&SourceId=1').pipe(
            map(this.extractData));
    }

    getExistingEquipments(companyId: number, customerId: number, customerEquipmentId: string): Observable<EquipmentEntity[]> {
        return this._http.get(API.CUSTOMER + '/GetExistingCustomerEquipments' + '?CompanyId=' + companyId + '&CustomerId=' + customerId + '&CustomerEquipmentId=' + customerEquipmentId).pipe(
            map(this.extractData));
    }

    wogetExistingEquipments(companyId: number, customerId: number, workOrderId: number, woJobId: number): Observable<EquipmentEntity[]> {
        return this._http.get(API.CUSTOMER + '/WOGetExistingCustomerEquipments' + '?CompanyId=' + companyId + '&CustomerId=' + customerId + '&WorkOrderId=' + workOrderId + '&WoJobId=' + woJobId).pipe(
            map(this.extractData));
    }

    UpdateExistEquipment(equipment: EquipmentEntity[]): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/SaveExistEquipment/', equipment).pipe(
            map(this.extractData));
    }

    deleteManageWoEquipment(companyId: number, woJobId: number, woEquipmentId: number, WorkorderId: number, LoginId: number): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeletManageWojobEquipment' + '?CompanyId=' + companyId + '&WoJobId=' + woJobId + '&WoEquipmentId=' + woEquipmentId + '&WorkOrderId=' + WorkorderId + '&LoginId' + LoginId + '&SourceId=1').pipe(
            map(this.extractData));
    }

    /**End job Equipment */

    /**Job History */
    getJobHistoryDetails(companyId: number, workOrderId: string, loginId: number, jobId: number): Observable<JobHistory[]> {
        return this._http.get(API.WORKORDER + '/GetWorkOrderHistoryDetails' + '?CompanyId=' + companyId + '&WoNumber=' + workOrderId + '&WojobId=' + jobId + '&SearchKey=' + "" + '&loginId=' + loginId).pipe(
            map(this.extractData));
    }
    /**End History */

    /**Technician Update Status */

    updateTechnicianJobStatus(technicianJobStatus: TechnicianJobStatusUpdate): Observable<FPResponse> {

        return this._http.post(API.SCHEDULING + '/UpdateTechnicianJobStatus/', technicianJobStatus).pipe(
            map(this.extractData));
    }

    /**End Technician Update Status */


    /**Attachement */
    getAttachementsDetails(companyId: number, filterBy: number, woJobId: number): Observable<AttachmentsModel[]> {
        return this._http.get(API.WORKORDER + '/GetManageWoAllAttachement' + '?CompanyId=' + companyId + '&FilterBy=' + filterBy + '&WoJobId=' +
            woJobId).pipe(
                map(this.extractData));
    }

    getPhotoDocumentDetails(companyId: number, configMasterId: number): Observable<Titles[]> {
        return this._http.get(API.CONFIGMASTER + '/GetAll' + '?CompanyID=' + companyId + '&ConfigID=' + configMasterId).pipe(
            map(this.extractData));
    }

    saveAttachement(model: AttachmentsModel[]) {

        return this._http.post(API.WORKORDER + '/ManageWoSaveAttachment/', model).pipe(
            map(this.extractData));
    }

    saveAttachementReorder(model: AttachmentReOrderList[]) {
        return this._http.post(API.WORKORDER + '/SaveAttachmentReOrder/', model).pipe(
            map(this.extractData));
    }


    saveJobAttachement(model: AttachmentsModel[]) {

        return this._http.post(API.WORKORDER + '/SaveAttachment/', model).pipe(
            map(this.extractData));
    }
    deleteAttachement(companyId: number, attachementId: number): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeleteAttachment' + '?CompanyId=' + companyId + '&WoAttachmentId=' + attachementId + '&SourceId=1').pipe(
            map(this.extractData));
    }

    downloadFile(companyId: number, woAttachmentId: number): Observable<string> {

        return this._http.get(API.WORKORDER + '/Download' + '?CompanyId=' + companyId + '&WoAttachmentId=' + woAttachmentId).pipe(
            map(this.extractData));
    }
    /**Attachement */

    /** CheckList */

    getCheckListAll(companyId: number, woJobId: number): Observable<ChecklistModel[]> {
        return this._http.get(API.WORKORDER + "/GetWOJobChecklist" + "?CompanyId=" + companyId + "&JobId=" + woJobId).pipe(
            map(this.extractData));
    }
    //   getValidationCheckList(companyId: number, woJobId: number) {
    //         return this._http.get(API.WORKORDER + "/TechJobSubmitChecklist" + "?CompanyId=" + companyId + "&JobId=" + woJobId)
    //             .map(this.extractData);
    //     }

    getCheckListName(companyId: number, woJobId: number, taskId: number[]): Observable<ChecklistModel[]> {

        return this._http.post(API.WORKORDER + "/GetWOJobChecklistDropDown" + "?CompanyId=" + companyId + "&JobId=" + woJobId, taskId).pipe(
            map(this.extractData));
    }

    saveCheckList(checkListModel: ChecklistModel, companyId: number): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + "/InsertWOJobChecklistDetails" + "?CompanyId=" + companyId, checkListModel).pipe(
            map(this.extractData));
    }

    deleteCheckList(companyId: number, woJobId: number, chklistMastId: number, ChkMastId: number, LoginId: number): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeleteWOJobChecklistDetails' + '?CompanyId=' + companyId + '&WoJobId=' + woJobId + '&WoJobChklistId=' + chklistMastId + '&ChkMastId=' + ChkMastId + '&LoginId=' + LoginId).pipe(
            map(this.extractData));
    }

    /**Dynamic Check List */

    getDynamicCheckList(companyId: number, WoJobChecklistId: number, ChklistMastId: number, Wojobid: number): Observable<DynamicCheckListDetails[]> {

        return this._http.get(API.WORKORDER + "/GetDynamicCheckListDetails1" + "?CompanyId=" + companyId + "&WoJobChecklistId=" +
            WoJobChecklistId + "&ChklistMastId=" + ChklistMastId + "&Wojobid=" + Wojobid).pipe(
                map(this.extractData));
    }

    /** End CheckList */

    /**payment model */

    getPaymentDetails(companyId: number, woJobId: number): Observable<PaymentModel> {
        return this._http.get(API.WORKORDER + "/GetWoJobPayment" + "?CompanyId=" + companyId + "&Wojobid=" + woJobId).pipe(
            map(this.extractData));
    }

    insertPaymentDetails(payment: PaymentModel): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/InsertWoJobPayment/', payment).pipe(
            map(this.extractData));
    }

    UpdatePaymentDetails(payment: PaymentModel): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateWoJobPayment/', payment).pipe(
            map(this.extractData));
    }

    /** End payment model */

    /**pricing details */

    getPricingDetails(companyId: number, woJobId: number): Observable<PricingModel[]> {
        return this._http.get(API.WORKORDER + "/GetWoJobPriceDetails" + "?CompanyId=" + companyId + "&woJobId=" + woJobId).pipe(
            map(this.extractData));
    }

    getPriceDiscountTypes(companyId: number): Observable<ConfigValue[]> {
        return this._http.get(API.CONFIGMASTER + "/GetConfigValueAll" + "?CompanyID=" + companyId).pipe(
            map(this.extractData));
    }

    savePricingDetails(payment: PricingFormModel): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/InsertWoJobPrice/', payment).pipe(
            map(this.extractData));
    }

    updatePricingDetails(payment: PricingFormModel): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateWoJobPrice/', payment).pipe(
            map(this.extractData));
    }
    updatepartPricingDetails(partprice: PartPricing): Observable<FPResponse> {

        return this._http.put(API.PART + '/UpdateWoPartPrice/', partprice).pipe(
            map(this.extractData));
    }

    deletePartPricing(companyId: number, WoPartPriceId: number): Observable<FPResponse> {

        return this._http.delete(API.PART + '/DeleteWoPartPrice' + '?CompanyId=' + companyId + '&WoPartPriceId=' + WoPartPriceId).pipe(
            map(this.extractData));
    }
    deletePricing(companyId: number, WoPriceId: number, WoJobId?: number): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeleteWoJobPrice' + '?CompanyId=' + companyId + '&WoPriceId=' + WoPriceId + '&WoJobId=' + WoJobId).pipe(
            map(this.extractData));
    }
   
    deleteVendorCost(companyId: number, WoJobPriceId: number,wojobid?:number): Observable<FPResponse> {
        return this._http.delete(API.APPROVALQUEUE + '/DeleteWoJobVendorCost' + '?WoJobPriceId=' + WoJobPriceId + '&CompanyId=' + companyId + '&wojobid=' + wojobid).pipe(
            map(this.extractData));
    }

    getPricingJobDetails(companyId: number, woJobId: number): Observable<WoJobTaskDetails[]> {
        return this._http.get(API.WORKORDER + '/GetWOJobDetails' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    /**end pricing details */

    /**signature */

    getJobSignature(companyId: number, woJobId: number): Observable<SigNature[]> {
        return this._http.get(API.SCHEDULING + '/GetWOJobSignature' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    getJobSignatures(companyId: number, woJobId: number): Observable<string> {
        return this._http.get(API.SCHEDULING + '/GetWOJobSignatures' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    updateSignatureDetails(model: SigNature): Observable<FPResponse> {

        return this._http.post(API.SCHEDULING + '/UpdateWOJobSignature/', model).pipe(
            map(this.extractData));
    }

    /**end signature */

    /**Recent order history */

    getRecentOrderHistory(companyId: number, customerId: number, loginId: number, RecCount: number, RecordDays: number): Observable<RecentOrderHistory[]> {
        return this._http.get(API.WORKORDER + '/GetRecentOrders' + '?CompanyId=' + companyId + '&CustomerId=' + customerId + '&LoginId=' + loginId + '&SearchKey=' + "" + '&RecCount=' + RecCount + '&RecordDays=' + RecordDays).pipe(
            map(this.extractData));
    }
    /**End Recent order history */

    SaveAttachmentDetails(model: AttachmentsModel): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/SaveAttachment/', model).pipe(
            map(this.extractData));
    }

    /**dynamic checklist */

    saveDynamicCheckList(payment: SaveDynamicChecklist): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/SaveDynamicCheckListDetails/', payment).pipe(
            map(this.extractData));
    }

    getDynamicCheckListAnswers(companyId: number, WoJobChecklistId: number): Observable<DynamicSaveModel[]> {

        return this._http.get(API.WORKORDER + "/GetDynamicCheckListAnswers" + "?CompanyId=" + companyId + "&WoJobChecklistId=" + WoJobChecklistId).pipe(
            map(this.extractData));
    }

    getDynamicCheckListQuestionAnswers(companyId: number, WoJobChecklistId: number): Observable<DynamicModel> {

        return this._http.get(API.WORKORDER + "/GetDynamicCheckListQuestionAnswers" + "?CompanyId=" + companyId + "&WoJobChecklistId=" + WoJobChecklistId).pipe(
            map(this.extractData));
    }

    checkTechJobValidation(model: UpdateSubmiteStatus): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + "/TechJobSubmitButtonValidate/", model).pipe(
            map(this.extractData));
    }

    UpdateTechjobStatus(model: UpdateSubmiteStatus): Observable<number[]> {
        return this._http.post(API.SCHEDULING + "/UpdateTechFormSubmit/", model).pipe(
            map(this.extractData));
    }

    /**Manage Workoredr - Screen */
    insertWoNewEquipment(equipment: WoEquipmentCFModel): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/SaveManageWoEquipment/', equipment).pipe(
            map(this.extractData));
    }

    updateWoEquipment(equipment: WoEquipmentCFModel): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateManageWoEquipments/', equipment).pipe(
            map(this.extractData));
    }
    /**End Manage Workoredr - Screen */

    /**Manage Workorder Attachement */
    getWoAttachementsDetails(companyId: number, WorkOrderId: number, filterBy: number, CusTimeZoneId: number): Observable<WoAttachement> {
        return this._http.get(API.WORKORDER + '/GetWoAttachement' + '?CompanyId=' + companyId + '&WorkOrderId=' + WorkOrderId + '&FilterBy=' + filterBy + '&TimeZoneId=' + CusTimeZoneId).pipe(
            map(this.extractData));
    }
    getAttachementsImage(companyId: number, WorkOrderId: number): Observable<AttachmentsModel[]> {
        return this._http.get(API.WORKORDER + '/GetWoAttachementDetails' + '?CompanyId=' + companyId + '&WorkOrderId=' + WorkOrderId).pipe(
            map(this.extractData));
    }
    getJobAttachementsImage(companyId: number, JobId: number): Observable<AttachmentsModel[]> {
        return this._http.get(API.WORKORDER + '/GetJobAttachementDetails' + '?CompanyId=' + companyId + '&JobId=' + JobId).pipe(
            map(this.extractData));
    }
    /**End Manage Workorder Attachement */

    getCustomerTime(CusTimeZoneId: number): Observable<CustomerTimeZone> {
        return this._http.get(API.WORKORDER + '/GetCustomerTimeZone/' + CusTimeZoneId).pipe(
            map(this.extractData));
    }

    //ShowSReport
    showSReport(companyId: number, categoryId: number) {
        return this._http.get(API.WORKORDER + '/ShowSReport/' + companyId + "/" + categoryId).pipe(map(this.extractData));
    }

    GetCompanyLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this._http.get(API.COMPANY + "/GetCompanyLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }
    GetPrintoutLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this._http.get(API.COMPANY + "/GetPrintoutLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }
    GetPrintoutHeader(CompanyId: number, FileName: string): Observable<Logo> {

        return this._http.get(API.COMPANY + "/GetPrintoutHeader/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }
    GetPrintoutFooter(CompanyId: number, FileName: string): Observable<Logo> {

        return this._http.get(API.COMPANY + "/GetPrintoutFootor/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }
    getCompany(companyId: number): Observable<Company> {
        return this._http.get(API.COMPANY + '/Get/?CompanyId=' + companyId).pipe(map(res => res.json()));
    }


    /**Noted Add,Edit,Delete */
    addNewNotes(specialService: NotesModel): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/InsertNotes/', specialService).pipe(
            map(this.extractData));
    }

    updateNotes(specialService: NotesModel): Observable<FPResponse> {
        return this._http.put(API.WORKORDER + '/UpdateNotes/', specialService).pipe(
            map(this.extractData));
    }

    deleteNotes(companyId: number, noteId: number): Observable<FPResponse> {
        return this._http.delete(API.WORKORDER + '/DeleteWojobServiceNotes' + '?CompanyId=' + companyId + '&NotesID=' + noteId).pipe(
            map(this.extractData));
    }

    /******** Job Details ************/

    getWoJobDetail(companyId: number, woJobId: number, SortBy: string, OrderBy: string, startRecord: number, EndRecord: number): Observable<JobDetailListTab> {
        return this._http.get(API.WORKORDER + '/GetWOJobDetailsWeb' + '?CompanyId=' + companyId + '&JobId=' + woJobId + '&SortBy=' + SortBy + '&OrderBy=' + OrderBy + '&startRecord=' + startRecord + '&EndRecord=' + EndRecord).pipe(
            map(this.extractData));
    }

    getJobDetails(companyId: number, woJobId: number): Observable<JobDetailsList[]> {
        return this._http.get(API.WORKORDER + '/GetWOJobDetails' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    getWoJobDetails(companyId: number, woJobId: number): Observable<WoJobTaskDetails[]> {
        return this._http.get(API.WORKORDER + '/GetWOJobDetails' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }
    //Added by Balaji 12/03/2019 print pre view
    getWoJobDetailsPrint(companyId: number, JobId: number[], WorkOrderId: number, TechId: number): Observable<JobPrintPre[]> {
        return this._http.post(API.WORKORDER + '/GetWOJobDetailsPrint' + '?CompanyId=' + companyId + '&WorkOrderId=' + WorkOrderId + '&TechId=' + TechId, JobId).pipe(
            map(this.extractData));
    }
    getWorkorderJobDetailsPrint(companyId: number, JobId: number[], WorkOrderId: number, TechId: number): Observable<JobPrintPre[]> {
        return this._http.post(API.WORKORDER + '/GetWorkOrderJobDetailsPrint' + '?CompanyId=' + companyId + '&WorkOrderId=' + WorkOrderId + '&TechId=' + TechId, JobId).pipe(
            map(this.extractData));
    }
    getWorkTypes(companyId: number, woCategoryId: number): Observable<WorkTypeDd[]> {
        return this._http.get(API.WORKORDERMAS + '/GetAllWorkType' + '?CompanyId=' + companyId + '&WoCategoryId=' + woCategoryId).pipe(
            map(this.extractData));
    }
    getWorkCategory(companyId: number) {
        return this._http.get(API.WORKORDERMAS + "/GetWorkCategoryDetails" + "?CompanyId=" + companyId + "&isActive=1").pipe(map(res => res.json()));
    }
    getAllWorkTask(companyId: number, workTypeId: number, workGroupId?: number): Observable<WorkRequestDd[]> {
        if(workGroupId)
        return this._http.get(API.WORKORDERMAS + '/GetAllWorkTask' + '?CompanyId=' + companyId + '&WorkTypeId=' + workTypeId + '&WorkGroupId=' + workGroupId).pipe(
            map(this.extractData));
            else
            return this._http.get(API.WORKORDERMAS + '/GetAllWorkTask' + '?CompanyId=' + companyId + '&WorkTypeId=' + workTypeId).pipe(
                map(this.extractData));
    }

    insertJobDetails(jobTaskDetails: WorkRequestCFModel): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/InsertWoJobDetailscf/', jobTaskDetails).pipe(
            map(this.extractData));
    }

    updateJobDetails(jobTaskDetails: WorkRequestCFModel): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateWoJobDetailscf/', jobTaskDetails).pipe(
            map(this.extractData));
    }

    deleteJobDetails(woJobId: number, woJobDetailsId: number, companyId: number, loginId: number): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeleteWoJobDetails/' + '?woJobId=' + woJobId + '&WoJobDetailsId=' + woJobDetailsId + '&CompanyId=' + companyId + '&LastUpdatedBy=' + loginId).pipe(
            map(this.extractData));
    }

    /******** Job Details End ************/

    /**Equipment */
    getEquipmentDetails(companyId: number, woJobId: number): Observable<EquipmentListModel[]> {
        return this._http.get(API.WORKORDER + '/GetEquipment' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    insertEquipment(equipment: EquipmentCFModel): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/SaveEquipmentcf/', equipment).pipe(
            map(this.extractData));
    }

    getExistingEquipmentDetails(companyId: number, customerId: number, customerEquipmentId: string): Observable<ExistingEquipmentModel[]> {
        return this._http.get(API.CUSTOMER + '/GetExistingCustomerEquipments' + '?CompanyId=' + companyId + '&CustomerId=' + customerId + '&CustomerEquipmentId=' + customerEquipmentId).pipe(
            map(this.extractData));
    }

    checkCheckListAvailable(CompanyId: number, WojobId: number): Observable<FPResponse> {
        return this._http.get(API.WORKORDER + '/CheckCheckListAvailable/' + CompanyId + '/' + WojobId).pipe(
            map(this.extractData));
    }

    saveOtherInfoCF(pkId: number, customFields: CustomFieldsConfiguration): Observable<FPResponse> {
        return this._http.post(API.CUSTOMFILEDS + '/Insert?PkId=' + pkId, customFields).pipe(map(res => res.json()));
    }
    getPricingExist(CompanyId: number, WoJobId: number): Observable<FPResponse> {
        return this._http.get(API.WORKORDER + "/ExistTechSubmit/" + CompanyId + "/" + WoJobId).pipe(map(res => res.json()));
    }
    editPricingExist(CompanyId: number, WoJobId: number): Observable<FPResponse> {
        return this._http.get(API.WORKORDER + "/editPricingExist/" + CompanyId + "/" + WoJobId).pipe(map(res => res.json()));
    }
    deletePricingExist(CompanyId: number, WoJobId: number): Observable<FPResponse> {
        return this._http.get(API.WORKORDER + "/DeletePricingExist/" + CompanyId + "/" + WoJobId).pipe(map(res => res.json()));
    }


    getBrandList(CompanyId: number): Observable<BrandList[]> {
        return this._http.get(API.PART + '/GetBrandList/' + CompanyId).pipe(map(res => res.json()));
    }
    getModelList(CompanyId: number, brandId: number): Observable<ModelList[]> {
        return this._http.get(API.PART + '/GetModelList/' + CompanyId + '/' + brandId).pipe(map(res => res.json()));
    }

    //Added by Anvardeen Batcha -- while job complete check part request status
    getPartStatusCount(CompanyId: number, WorkOrderId: number, WoJobId: number): Observable<FPResponse> {
        return this._http.get(API.PART + "/GetPartStatusCount/" + CompanyId + "/" + WorkOrderId + "/" + WoJobId).pipe(map(res => res.json()));
    }
    //Added by Anvardeen Batcha -- while job complete check part request status

    //added by senthilg
    getProjects(CompanyId: number) {
        return this._http.get(API.PROJECT + "/GetProjects/" + CompanyId).pipe(map(resp => resp.json()));
    }
    GetWorkCategory(CompanyId: number) {
        return this._http.get(API.WORKORDERMAS + "/GetWorkCategory/" + CompanyId).pipe(map(resp => resp.json()));
    }
    //Based on multi country purpose changed the  code Company country 23/02/2018
    // getTimeZone(LoginId: number,CompanyId: number, CountryId: number) {
    //     return this._http.get(API.USER + "/GetTimeZone/" + LoginId + "/" + CompanyId + "/" + CountryId).map(resp => resp.json());
    // }
    getTimeZone(LoginId: number, CompanyId: number) {
        return this._http.get(API.USER + "/GetTimeZone/" + LoginId + "/" + CompanyId).pipe(map(resp => resp.json()));
    }
    //Based on multi country purpose changed the  code Company country 23/02/2018
    getUserTimeZone(timezoneId: number): Observable<TimezoneEntity> {
        return this._http.get(API.WORKORDER + "/GetUserTimeZone?TimeZoneId=" + timezoneId).pipe(map(resp => resp.json()));
    }
    getPriorities(CompanyId: number): Observable<any> {
        return this._http.get(API.WOPRIORITY + "/GetPriorities/" + CompanyId).pipe(map(res => res.json()));
    }
    GetContractType(CompanyId: number): Observable<ContractType[]> {
        return this._http.get(API.MODEL + '/GetContract/' + CompanyId).pipe(map(res => res.json()));
    }
    private extractData(res: Response) {
        //  
        let body = res.json();
        return body || {};
    }

    private handleError(error: any) {

        console.error('an error occured', error);
        return Promise.reject(error.message || error);
    }

    insertContactWithCF(cc: ContactCFModel): Observable<FPResponse> {
        return this._http.post(API.CUSTOMER + '/AddCustomerContactWithCF', cc).pipe(map(res => res.json()));
    }

    getTaxGroup(CompanyId: number, TaxTypeId: number): Observable<TaxGroup[]> {
        return this._http.get(API.TAXGROUPMASTER + "/GetTaxGroup/?CompanyId=" + CompanyId + '&TaxTypeId=' + TaxTypeId).pipe(map(res => res.json()));
    }

    getJobSLADetails(jobId: number, companyId: number): Observable<JobSlaDetails[]> {
        return this._http.get(API.DISPATCHBOARD + "/GetJobSLADetails/" + jobId + '/' + companyId).pipe(map(res => res.json()));
    }

    getcheckListPrintData(model: PrintcheckListModel[]): Observable<PrintCheckListOutput> {
        return this._http.post(API.WORKORDER + '/getcheckListPrintData', model).pipe(map(res => res.json()));
    }

    GetCheckListLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this._http.get(API.COMPANY + "/GetCheckListLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }

    GetCheckHeaderLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this._http.get(API.COMPANY + "/GetCheckHeaderLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }

    GetCheckFootorLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this._http.get(API.COMPANY + "/GetCheckFootorLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }

    ExportExcelCheckList(model: PrintcheckListModel[]): Observable<DownloadFile> {
        return this._http.post(API.WORKORDER + "/exportExcelCheckList", model).pipe(map(res => res.json()));

    }

    getPartRequestList(CompanyId: number, WorkOrderId: number, WoJobId: number) {
        return this._http.get(API.PART + "/GetPartRequestList/" + CompanyId + "/" + WorkOrderId + '/?WoJobId=' + WoJobId).pipe(map(resp => resp.json()));
    }

    getWoSLAHistory(CompanyId: number, WoId: number, WoJobId: number) {
        return this._http.get(API.WORKORDER + "/GetSLAHistory?CompanyId=" + CompanyId + "&WoId=" + WoId + "&WoJobId=" + WoJobId).pipe(map(resp => resp.json()));
    }

    eJobDownload(eJobDownload: EmailJobAttachement) {
        return this._http.post(API.WORKORDER + "/eJobAttachement", eJobDownload).pipe(map(resp => resp.json()));
    }

    SendEmailJob(model: SendEmailJob): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + "/SendEmailJob", model).pipe(map(resp => resp.json()));
    }
    SendInvoiceEmailJob(model: SendEmailJob[]): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + "/SendInvoiceEmailJob", model).pipe(map(resp => resp.json()));
    }
    getJoblist(CompanyId: number, WorkOrderId: number): Observable<jobNumber[]> {
        return this._http.get(API.WORKORDER + "/GetJobList?CompanyId=" + CompanyId + "&WorkOrderId=" + WorkOrderId).pipe(map(resp => resp.json()));
    }

    getSystemSettings(companyId: number, settingsId: number[]): Observable<SystemSettings[]> {
        return this._http.post(API.WORKORDER + '/GetSystemSettings', { CompanyId: companyId, SettingsId: settingsId }).pipe(
            map(this.extractData));
    }

    TechJobCompleteValidation(CompanyId: number, Jobid: number): Observable<FPResponse> {
        return this._http.get(API.WORKORDER + "/TechJobCompleteValidation/" + CompanyId + "/" + Jobid).pipe(map(resp => resp.json()));
    }

    getTechnicianMaster(CompanyId: number, Id: number): Observable<TechnicianDetail> {
        return this._http.get(API.USER + "/GetTechnician/" + CompanyId + "/" + Id).pipe(map(res => res.json()));
    }

    getValidateOTP(CompanyId: number, WoAppointmentId: number, OTP: string) {
        return this._http.get(API.SCHEDULING + "/OTPValidation/" + CompanyId + "/" + WoAppointmentId + "/" + OTP).pipe(map(resp => resp.json()));
    }

    insertotp(saveotpdetails: SaveOTP): Observable<FPResponse> {

        return this._http.post(API.SCHEDULING + '/InsertOTP/', saveotpdetails).pipe(
            map(this.extractData));
    }

    updateotp(saveotpdetails: SaveOTP): Observable<FPResponse> {

        return this._http.put(API.SCHEDULING + '/UpdateOTP/', saveotpdetails).pipe(
            map(this.extractData));
    }

    getReason(companyId: number): Observable<Reason[]> {
        return this._http.get(API.SCHEDULING + '/GetReason' + '?CompanyId=' + companyId).pipe(
            map(this.extractData));
    }

    getOTPdetails(CompanyId: number, WoAppointmentId: number): Observable<OTPDetails> {
        return this._http.get(API.SCHEDULING + "/GetOTP/" + CompanyId + "/" + WoAppointmentId).pipe(map(resp => resp.json()));
    }

    ResendOTP(CompanyId: number, LoginId: number, WorkOrderId: number, WoJobId: number, WoAppointmentId: number, JobStatusId: number, MobileNo: string): Observable<FPResponse> {
        return this._http.get(API.SCHEDULING + "/ResendOTP?CompanyId=" + CompanyId + "&LoginId=" + LoginId + "&WorkOrderId=" + WorkOrderId + "&WoJobId=" + WoJobId + "&WoAppointmentId=" + WoAppointmentId + "&JobStatusId=" + JobStatusId + "&MobileNo=" + MobileNo).pipe(map(resp => resp.json()));
    }

    ResendOTPWeb(Entity: any): Observable<FPResponse> {
        return this._http.post(API.SCHEDULING + "/ResendOTPWeb", Entity).pipe(map(resp => resp.json()));
    }

    InsertCustomerFeedback(feedback: Feedback): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + "/InsertCustomerFeedback", feedback).pipe(map(res => res.json()));
    }
    UpdateCustomerFeedback(feedback: Feedback): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + "/UpdateCustomerFeedback", feedback).pipe(map(res => res.json()));
    }
    GetByCustomerFeedBack(Jobid: number, companyId: number): Observable<Feedback[]> {
        return this._http.post(API.WORKORDER + "/GetByCustomerFeedBack/" + Jobid + "/" + companyId, []).pipe(map(res => res.json()));
    }

    getCustomerTypes(companyId: number): Observable<CustomerType[]> {
        return this._http.get(API.CUSTOMER + '/GetCustomerTypes/' + companyId).pipe(map(res => res.json()));
    }
    GetAllRejectReason(companyId: number): Observable<RefStatusReasonReject[]> {
        return this._http.get(API.STATUSREASON + '/GetAllReject/' + companyId).pipe(map(res => res.json()));
    }

    cancelAppointment(PiCompanyId: number, PiloginId: number, PiWoJobId: number, PiCancelReasonId: number, PiSourceId: number) {
        return this._http.post(API.WORKORDER + "/CancelAppointment/" + PiCompanyId + "/" + PiloginId + "/" + PiWoJobId + "/" + PiCancelReasonId + "/" + PiSourceId, {}).pipe(map(resp => resp.json()));
    }

    updateAcceptReject(updateaccrej: AcceptReject): Observable<FPResponse> {

        return this._http.put(API.STATUSREASON + '/UpdateAcceptRejectJob/', updateaccrej).pipe(
            map(this.extractData));
    }

    getacceptancestatus(CompanyId: number, WoJobId: number): Observable<FPResponse> {

        return this._http.get(API.STATUSREASON + '/GetAcceptanceStatus/' + CompanyId + "/" + WoJobId).pipe(
            map(res => res.json()));
    }

    getchklistAttachementsDetails(Companyid: number, ChklistDtlId: number, ChklistMastId: number, WoJobChklistDtlId: number, filterBy: number): Observable<attachmentchecklist[]> {
        return this._http.get(API.WORKORDER + '/GetchkAttachmentByQuestionId' + '?Companyid=' + Companyid + '&ChklistDtlId=' + ChklistDtlId + '&ChklistMastId=' + ChklistMastId + '&WoJobChklistDtlId=' + WoJobChklistDtlId + '&filterBy=' +
            filterBy).pipe(
                map(this.extractData));
    }
    DeleteChecklistattachment(Companyid: number, WoJobId: number, WoJobChklistDtlListId: number, chkdetailid: number, ChklistMastId: number): Observable<FPResponse> {
        return this._http.delete(API.WORKORDER + '/DeleteChecklistAttachment' + '?Companyid=' + Companyid + '&WoJobId=' + WoJobId + '&WoJobChklistDtlListId=' + WoJobChklistDtlListId + '&chkdetailid=' +
            chkdetailid + '&ChklistMastId=' + ChklistMastId).pipe(
                map(this.extractData));
    }
    getCheckListattachmentPrintDetails(companyId: number, woJobId: number, masterId: number[]): Observable<attachmentchecklist[]> {

        return this._http.post(API.WORKORDER + "/getcheckListPrintDataAttachment" + "?CompanyId=" + companyId + "&JobId=" + woJobId, masterId).pipe(
            map(this.extractData));
    }

    savechklistAttachement(model: ChecklistAttachment[]) {
        return this._http.post(API.WORKORDER + '/ChklistSaveAttachment/', model).pipe(
            map(this.extractData));
    }

    getJobFormAttachementsImage(companyId: number, JobId: number, WoJobChklistDtlId: number): Observable<AttachmentsModel[]> {
        return this._http.get(API.WORKORDER + '/GetJobFormAttachementDetails' + '?CompanyId=' + companyId + '&JobId=' + JobId + '&WoJobChklistDtlId=' + WoJobChklistDtlId).pipe(
            map(this.extractData));
    }

    getMetaDataInfo(companyId: number, filePath: string, fileName: string): Observable<any[]> {
        return this._http.get(API.WORKORDER + '/GetAttachmentFileInfo' + '?CompanyID=' + companyId + '&FilePath=' + filePath + '&FileName=' + fileName).pipe(
            map(this.extractData));
    }
    getChecklistLatLongValues(companyId: number, WoJobId: number): Observable<ChecklistGPSLocation[]> {
        return this._http.get(API.WORKORDER + '/GetChecklistLatLongValues' + '?CompanyId=' + companyId + '&WoJobId=' + WoJobId).pipe(
            map(this.extractData));
    }

    //#region - Sprint 68
    GetJobRMAPartDetails(CompanyId: number, WoJobId: number) {
        return this._http.get(API.WORKORDER + '/GetJobRMAPartDetails/' + CompanyId + '/' + WoJobId).pipe(
            map(this.extractData));
    }
    GetWoJobStatusReason(CompanyId: number, WoJobId: number, JobStatusId: number, NoteMasterId: number): Observable<WoJobStatusReasonEntity[]> {
        return this._http.get(API.STATUSREASON + '/GetWoJobStatusReason/' + CompanyId + '/' + WoJobId + "/" + JobStatusId + "/" + NoteMasterId).pipe(
            map(this.extractData));
    }
    SaveWoJobStatusReason(Model: SaveCompleteStatusReason): Observable<FPResponse> {
        return this._http.post(API.STATUSREASON + '/SaveWoJobStatusReason', Model).pipe(
            map(this.extractData));
    }
    SaveInprogressandOnholdJobStatusReason(Model: SaveCompleteStatusReason): Observable<FPResponse> {
        return this._http.post(API.STATUSREASON + '/SaveJobStatusReason', Model).pipe(
            map(this.extractData));
    }
    //#endregion

    DeleteAttachmentFile(model: FileDetails[]) {

        return this._http.post(API.WORKORDER + '/DeleteWOFile/', model).pipe(map(res => res.json()));
    }

    DeleteChecklistAttachmentFile(model: ChecklistFileDetails[]) {
        return this._http.post(API.WORKORDER + '/DeleteChecklistFile/', model).pipe(
            map(this.extractData));
    }
    GetAvailability(model: ScheduleToMe) {
        return this._http.post(API.WORKORDER + '/GetAvilableTime/', model).pipe(
            map(this.extractData));
    }
    insertAssignToTech(assignToTech: AssignToTech[]): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/InsertAssignToTech', assignToTech).pipe(map(res => res.json()));
    }
    addWoJob(addEditWoJobEntity: AddEditWoJobEntity) {
        return this._http.post(API.WORKORDER + "/AddJobfromPunch", addEditWoJobEntity).pipe(map(resp => resp.json()));
    }
    GetUserRole(companyId: number, loginId: number): Observable<userRoleDetail[]> {
        return this._http.get(API.WORKORDER + '/GetUserRole' + '?CompanyId=' + companyId + '&loginId=' + loginId).pipe(
            map(this.extractData));
    }
    getPunchPoints(companyId: number, WoJobId: number, WorkOrderId: number): Observable<PunchPointsList[]> {
        return this._http.get(API.WORKORDER + '/GetWOPunchPoints' + '?CompanyId=' + companyId + '&WoJobId=' + WoJobId + '&WorkOrderId=' + WorkOrderId).pipe(
            map(this.extractData));
    }
    deletePunch(companyId: number, WOPunchPointsId: number): Observable<FPResponse> {
        return this._http.get(API.WORKORDER + '/DeletePunchPoints' + '?CompanyId=' + companyId + '&WOPunchPointsId=' + WOPunchPointsId).pipe(
            map(this.extractData));
    }
    deletePunchAttachment(companyId: number, WoPunchPointsAttachmentId: number): Observable<FPResponse> {
        return this._http.get(API.WORKORDER + '/DeletePunchAttachment' + '?CompanyId=' + companyId + '&WoPunchPointsAttachmentId=' + WoPunchPointsAttachmentId).pipe(
            map(this.extractData));
    }
    insertPunch(punchDetails: WOPunchPoints): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/InsertWOPunchPoints/', punchDetails).pipe(
            map(this.extractData));
    }
    getPunchAttachment(companyId: number, WOPunchPointsId: number, isPreview: boolean): Observable<WoPunchPointsAttachment[]> {
        return this._http.get(API.WORKORDER + '/GetWoPunchAttachment' + '?CompanyId=' + companyId + '&WOPunchPointsId=' + WOPunchPointsId + '&isPreview=' + isPreview).pipe(
            map(this.extractData));
    }
    OTPProjectSettings(companyId: number, WorkOrderId: number): Observable<OTPProjectSettings> {
        return this._http.get(API.TECH_AVAILABILITY + '/OTPProjectSettings/' + companyId + '/' + WorkOrderId).pipe(
            map(this.extractData));
    }

    getSystemSettingById(companyId: number, settingId: number): Observable<number> {
        return this._http.get(API.SYSTEMSETTING + "/GetSystemSettingValue/" + companyId + "/" + settingId).pipe(map(resp => resp.json()));
    }
    GetJobDuration(companyId: number, woJobId: number) {
        return this._http.get(API.STATUSREASON + '/GetJobDetails/' + companyId + '/' + woJobId).pipe(
            map(this.extractData));
    }
    getWorkDoneTimings(CompanyId: number, WoJobId: number, loginId: number): Observable<WorkDoneTimings[]> {
        return this._http.get(API.WORKORDER + '/GetWorkDoneTimings/' + CompanyId + "/" + WoJobId + "/" + loginId).pipe(
            map(this.extractData));
    }
    GetActualHours(CompanyId: number, WoJobId: number) {
        return this._http.get(API.WORKORDER + '/GetActualHours/' + CompanyId + '/' + WoJobId).pipe(
            map(this.extractData));
    }

    getMapKey(Key:string): Observable<FPResponse> {

        return this._http.get(API.API_ADMIN + 'CompanyMaster/GetMapKey' + '?ProdMapKey=' + Key).pipe(
            map(this.extractData));
    }

    //Share data Between components
private SharedDatas =  new BehaviorSubject<number>(null);
setSharedDatas(inputdata:number) {  
  this.SharedDatas.next(inputdata);
}
getShareddatas():Observable<number>{
  return this.SharedDatas.asObservable();
}
clearMessages() {
  this.SharedDatas.next(null);
}

GetEmailPrintJobSetting(companyId: number): Observable<RefEmailPrintJobSetting[]> {
    return this._http.get(API.WORKORDER + '/GetEmailPrintJobSetting/' + companyId ).pipe(
        map(this.extractData));
}
getchklistJobPrintAttachementsDetails(Companyid: number, ChklistDtlId: number[]): Observable<attachmentchecklist[]> {
    return this._http.post(API.WORKORDER + '/GetchkJobPrintAttachmentByQuestionId' + '?Companyid=' + Companyid, ChklistDtlId).pipe(
        map(this.extractData));
}
//End
}
